{
  "version": 1,
  "asset_id": "a6c4cf86-2172-4134-bfbf-f985aae0fa35",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/a6c4cf86-2172-4134-bfbf-f985aae0fa35/ind-healthcare-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/a6c4cf86-2172-4134-bfbf-f985aae0fa35/ind-healthcare-640.webp",
  "original_filename": "ind-healthcare-640.webp",
  "size": 4930,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:01Z"
}
